/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { Ptw100ServiceUnavailableException } from './Ptw100ServiceUnavailableException';
import {
    Ptw100ServiceUnavailableExceptionFromJSON,
    Ptw100ServiceUnavailableExceptionFromJSONTyped,
    Ptw100ServiceUnavailableExceptionToJSON,
} from './Ptw100ServiceUnavailableException';

/**
 * 
 * @export
 * @interface ErrorResponseOfPtw100ServiceUnavailableException
 */
export interface ErrorResponseOfPtw100ServiceUnavailableException {
    /**
     * This code is used in the ExceptionMiddleware and will be set as the HTTP response status code
     * @type {number}
     * @memberof ErrorResponseOfPtw100ServiceUnavailableException
     */
    readonly httpStatusCode?: number;
    /**
     * 
     * @type {Ptw100ServiceUnavailableException}
     * @memberof ErrorResponseOfPtw100ServiceUnavailableException
     */
    exception: Ptw100ServiceUnavailableException;
    /**
     * 
     * @type {string}
     * @memberof ErrorResponseOfPtw100ServiceUnavailableException
     */
    $type?: ErrorResponseOfPtw100ServiceUnavailableExceptionTypeEnum;
}


/**
 * @export
 */
export const ErrorResponseOfPtw100ServiceUnavailableExceptionTypeEnum = {
    PtwPtw100WebSharedModelsErrorResponseErrorResponse1PtwPtw100AppZeroCoreSharedExceptionsPtw100ServiceUnavailableExceptionPtwPtw100AppZeroCoreSharedPtwPtw100WebShared: 'Ptw.Ptw100.Web.Shared.Models.ErrorResponse.ErrorResponse`1[[Ptw.Ptw100.AppZero.Core.Shared.Exceptions.Ptw100ServiceUnavailableException, Ptw.Ptw100.AppZero.Core.Shared]], Ptw.Ptw100.Web.Shared'
} as const;
export type ErrorResponseOfPtw100ServiceUnavailableExceptionTypeEnum = typeof ErrorResponseOfPtw100ServiceUnavailableExceptionTypeEnum[keyof typeof ErrorResponseOfPtw100ServiceUnavailableExceptionTypeEnum];



/**
 * Check if a given object implements the ErrorResponseOfPtw100ServiceUnavailableException interface.
 */
export function instanceOfErrorResponseOfPtw100ServiceUnavailableException(value?: unknown): value is ErrorResponseOfPtw100ServiceUnavailableException {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(ErrorResponseOfPtw100ServiceUnavailableExceptionTypeEnum)[0];
}

export function ErrorResponseOfPtw100ServiceUnavailableExceptionFromJSON(json: any): ErrorResponseOfPtw100ServiceUnavailableException {
    return ErrorResponseOfPtw100ServiceUnavailableExceptionFromJSONTyped(json, false);
}

export function ErrorResponseOfPtw100ServiceUnavailableExceptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ErrorResponseOfPtw100ServiceUnavailableException {
    if (json == null) {
        return json;
    }
    return {
        
        'httpStatusCode': json['httpStatusCode'] == null ? undefined : json['httpStatusCode'],
        'exception': Ptw100ServiceUnavailableExceptionFromJSON(json['exception']),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function ErrorResponseOfPtw100ServiceUnavailableExceptionToJSON(value?: Omit<ErrorResponseOfPtw100ServiceUnavailableException, 'httpStatusCode'> | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'exception': Ptw100ServiceUnavailableExceptionToJSON(value['exception']),
        '$type': value['$type'],
    });
}

